import GlobalContext from "./GlobalContext";
import {useEffect, useReducer, useState} from "react";
import dayjs from "dayjs";

const savedEventsReducer = (events, operation) => {
    const {type , payload} = operation;
    var newEvents = payload;
    switch (type) {
        case "push":
            console.log('ACTION PUSH ->', newEvents)
            return [...events, ...newEvents];
        case "update":
            console.log('ACTION UPDATE ->', newEvents)
            return events.filter(evt => evt.eventId !== newEvents.filter((e,i)=>i ===0)[0].eventId ).concat(newEvents);

        case "delete":
            console.log('ACTION DELETE ->', newEvents)
            //return  events.filter(evt => evt.eventId !== newEvents.filter((e,i)=>i ===0)[0].eventId);
            return  events.filter(evt => evt.eventId !== payload.eventId);
        default:
            throw new Error();


    }
}

const initEvents =()=>{
    const storageEvents = localStorage.getItem("savedEvents");
    return storageEvents ? JSON.parse(storageEvents) : [];
}

export default function ContextWrapper(props) {
    const [monthIndex, setMonthIndex] = useState(dayjs().month());
    const [smallCalendarMonth, setSmallCalendarMonth] = useState(null)
    const [daySelected, setDaySelected] = useState(dayjs());
    const [showEventModal, setShowEventModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [labels,setLabels] = useState([]);
    const [savedEvents, dispatchCalEvent] = useReducer(savedEventsReducer,[],initEvents);

useEffect(()=>{
    localStorage.setItem("savedEvents",JSON.stringify(savedEvents));
},[savedEvents]);

    useEffect(()=>{
        setLabels((prevLabel)=>{
            return [...new Set(savedEvents.map(evt=>evt.label))].map(label=>{
                const currentLabel = prevLabel.find(lbl=> lbl.label === label)
                return {
                    label,
                    checked: currentLabel ? currentLabel.checked :true,
                };
            });
        });
    },[savedEvents]);

    useEffect(() => {
        if (smallCalendarMonth !== null) {
            setMonthIndex(smallCalendarMonth)
        }

    }, [smallCalendarMonth]);
    return (
        <GlobalContext.Provider value={{
            monthIndex,
            setMonthIndex,
            smallCalendarMonth,
            setSmallCalendarMonth,
            daySelected,
            setDaySelected,
            showEventModal,
            setShowEventModal,
            dispatchCalEvent,
            savedEvents,
            selectedEvent,
            setSelectedEvent,
            labels,
            setLabels

        }}
        >
            {props.children}
        </GlobalContext.Provider>
    );
}